/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />
class OtherWiseController{
	//@ngInject
	constructor(
		$scope
	){
		$scope.$id="otherwiseController";
	}
}
export{OtherWiseController}

